<template>

  <div class="workshops-bespoke">

    <nav-1></nav-1>

    <!-- <hero :image="hero"></hero> -->
    <play></play>

    <!-- <div class="hero-wrapper">
      <div class="hero">
        <div class="background" :style="{'backgroundImage':'url(' + hero + ')'}"></div>
        <div class="text">

        </div>
      </div>
    </div> -->

    <div class="content-text">
      <h1>
        Play as a Method of Working
        <small>Playtotyping</small>
      </h1>

      <h4 class="size__content__default pos__content__center">
        Playtotyping is our approach and method of working. It engages and spurs people to play in order to solve a problem or answer a brief or quite simply to have fun and be creative.
      </h4>
      <h4 class="size__content__default pos__content__center">
        We use design, craft and technology to give people the tools to connect with their inherent creativity, to express their ideas and collaborate with each other.
      </h4>
      <h4 class="size__content__default pos__content__center">
        The overall aim of playtotyping is to move and inspire communities, clients and individuals to innovate and create new ways of thinking and doing through the art of play.
      </h4>
    </div>




    <div class="content-text outcomes">
      <h4 class="size__content__default pos__content__center">
        At HATO we believe that being playful and creative are part of the everyday. We use this ethos throughout our own practice. Through our public and private workshops programme we are able to engage others to do the same.
      </h4>
      <h4 class="size__content__default pos__content__center">
        Our experiential workshops are built around teams and groups wanting to explore play and creativity in a fun and inspiring way. Either hosted at our East London studio or at your own space be it your office/studio or temporary space, our team of workshop leaders and printers are able to devise tailored Riso printing and image making sessions that inspire new perspectives amongst teams and ensure a fun and engaging social event.
      </h4>
    </div>

    <div class="content-text outcomes-visual">
      <h2>Outcomes</h2>
      <div class="outcomes-boxes">
        <div class="outcomes-box">
          Creative Thinking
        </div>
        <div class="outcomes-box">
          Wellbeing
        </div>
        <div class="outcomes-box">
          Innovation
        </div>
        <div class="outcomes-box">
          Team Building
        </div>
        <div class="outcomes-box">
          Re-Engage<br>Kinesthetic
        </div>
        <div class="outcomes-box">
          Increase Visual<br>Learning methods
        </div>
      </div>
    </div>

    <div class="content-text cta">
      <div class="action">
        <h3>Let us customise your next workshop experience.</h3>
        <a href="mailto:bespoke@hatopress.net?subject=Bespoke Workshops">bespoke@hatopress.net</a>
        <a href="tel:+44-207-729-5585">+44 (0)207 729 5585</a>
      </div>
    </div>

    <div class="carousel-wrapper testimonials">

      <h2>What our clients say</h2>

      <flickity class="carousel" ref="flickity" :options="flickityOptions">
        <div class="carousel-cell quote">
          <h3>“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”</h3>
          <p>Shirley, Senior Copywriter, Virgin Media</p>
        </div>
        <div class="carousel-cell quote">
          <h3>“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to anyone!”</h3>
          <p>Emma, Graphic Designer, Boden</p>
        </div>
        <div class="carousel-cell quote xl">
          <!-- <h3>“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. Most had very little knowledge of Riso before hand and so was a lot of fun making a mess together, experimenting with ideas and picking your colours! The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”</h3> -->
          <h3>“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”</h3>
          <p>Helen Scibilia, Project Manager, YCN</p>
        </div>
        <div class="carousel-cell quote">
          <h3>“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a beer ;-).”</h3>
          <p>Alex Prior, Head of Graphic Design at The Hoxton</p>
        </div>
      </flickity>
    </div>

    <!-- <div class="quotes size__content__wide pos__content__center">
      <div class="quote">
        <h3>“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”</h3>
        <p>Shirley, Senior Copywriter, Virgin Media</p>
      </div>
      <div class="quote">
        <h3>“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to anyone!”</h3>
        <p>Emma, Graphic Designer, Boden</p>
      </div>
      <div class="quote">
        <h3>“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a beer ;-).”</h3>
        <p>Alex Prior, Head of Graphic Design at The Hoxton</p>
      </div>
      <div class="quote">
        <h3>“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”</h3>
        <p>Helen Scibilia, Project Manager, YCN</p>
      </div>
    </div> -->




    <!-- <div class="content-text">
      <img class="size__content__narrow" src="../assets/clients/corporate-logo-blocks.png" alt="">
    </div> -->
    <div class="content-logos">
      <img class="size__content__narrow" src="../assets/clients/playtotype-logos.png" alt="">
    </div>


    <div class="content-text cta">
      <div class="action">
        <h3>Let's begin.</h3>
        <a href="mailto:bespoke@hatopress.net?subject=Bespoke Workshops">bespoke@hatopress.net</a>
        <a href="tel:+44-207-729-5585">+44 (0)207 729 5585</a>
      </div>
    </div>
    <!-- <div class="content-text">
      <p>&nbsp;</p>
    </div> -->
    <!-- <div class="action-wrapper">
      <div class="action">
        <h3>Let us plan your next event,<br>book a bespoke session with us.</h3>
        <a href="#">learn@hatopress.net</a>
        <a href="#">+44 (0)207 729 5585</a>
      </div>
    </div> -->

  </div>

</template>

<script>

import Nav1 from '@/components/Nav1'
import Flickity from '@/components/Flickity'
import Hero from '@/components/Hero'
import Newsletter from '@/components/Newsletter'
import Play from '@/components/Play'

export default {
  ready: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  beforeDestroy: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  components: {
    Nav1,
    Flickity,
    Hero,
    Newsletter,
    Play
  },
  mounted () {
    this.$refs.flickity.initFlickity()
  },
  data () {
    return {
      hero: require('../assets/workshops/hatopress-whitechapel-closeup.jpg'),
      carousel: [
        {
          text: 'Bao',
          image: 'https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/17438461_174435699740537_1721658144775471104_n.jpg'
        }
      ],
      flickityOptions: {
        // contain: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        autoPlay: 3000
      }
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  margin-top: 0;
  /*text-align: center;*/
}
img {

}
small {
  display: block;
  margin: .5em;
  font-size: 60%
}
h2 {
  text-align: center;
}
.content-text {
  background: #fdda58;
  background: #fff;
  margin: auto;
  padding: 2rem 1rem 1rem;
  margin: 0 auto;
  text-align: left;
  /*max-width: 1000px;*/
}

.content-text h4 {
  margin-bottom: 1rem;
}

.content-logos {
  margin: 4rem auto 6rem;
}

.content-text.outcomes {
  background: #eee;
}

.action-wrapper {
  /*background: #f0f0f0;*/
  padding: 1rem 0;
}

.cta {
  /* background: yellow */
  background: #fafafa;
}

.action {
  padding: 2rem 0;
  margin: 0 auto;
  max-width: 600px;
  text-align: center;
}
.action a {
  display: inline-block;
  margin: 1rem .5rem;
  padding: .5em 1em;
  border-radius: 5px;
  /*border: 1px solid #000;*/
  background: hsl(158, 81%, 57%)
}
.action a:hover {
  background: hsl(158, 81%, 77%);
}

.flash {
   animation-name: flash;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}


@keyframes flash {
    0% {color: red;}
    20% {color: yellow;}
    40% {color: green;}
    60% {color: blue;}
    80% {color: pink;}
    100% {color: red;}
}




/* .quotes {
  padding: 0rem 0 0rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
} */
.quote:nth-child(2n) {
  background:
  /*align-self: flex-end;*/
}

.layout-b {
  /*background: rgb(55,234,168);*/
  max-width: 100%;
  justify-content: center;
  align-items: center;
}

.testimonials {
  background: #003;
  color: white;
}

.carousel-wrapper {
  padding: 1rem 0 2rem;
  width: 100%;
  position: relative;
}
.carousel {
  top:0;
  left: 0;
  width: 100%;
}
.carousel-cell {
  /* width: 900px;
  height: 550px;
  margin: 0 .5rem; */
  margin: 0 .5rem;
}
.quote {
  /* width: 49%; */
  color: black;
  width: 90%;
  max-width: 500px;
  padding: 2rem 2rem 2rem;
  border-radius: 5px;
  background: hsl(186, 81%, 57%);
}
.quote.xl {
  max-width: 700px;
}

.outcomes-visual {
  background:;
}
.outcomes-boxes {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto;
  max-width: 1000px;
  padding-bottom: 3rem;
}
.outcomes-box {
  padding: 3rem;
  background: yellow;
  font-size: 1.5rem;
  margin: .5rem;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1024px) {
  /* .quotes {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .content-logos {
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  } */
}
@media screen and (max-width: 768px) {
}
@media screen and (max-width: 640px) {
  .outcomes-box {
    font-size: 1rem;
    padding: 2rem;
  }
  /* .quotes {
    flex-direction: column;
  }
  .quote {
    width: 100%;
    margin-top: 0;
    margin-bottom: 1rem;
  }
  .action a {
    margin: .5em 1em;
  } */
}
</style>



// WEBPACK FOOTER //
// WorkshopsPlaytotype.vue?d123d68a